export default {
  "site.name": "OOPBUY Spreadsheet",
  "site.tagline": "Der ultimative Guide für smartes Shopping",
  "nav.home": "Startseite",
  "nav.categories": "Kategorien",
  "nav.articles": "Artikel",
  "nav.shopping_guide": "Einkaufsführer",
  "button.buy_now": "Buy it now",
  "button.learn_more": "Mehr erfahren",
  "button.read_more": "Weiterlesen",
  "button.back_home": "← Zurück zur Startseite",
  "footer.copyright": "© 2026 OOPBUY Spreadsheet. Alle Rechte vorbehalten.",
  "footer.impressum": "Impressum",
  "footer.privacy": "Datenschutz",
  "footer.contact": "Kontakt",
  "footer.disclaimer": "Haftungsausschluss",
};